var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChangeLanguage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 16,
    fill: "url(#paint0_linear_482_3735)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 8C20.5013 10.7384 21.9228 14.292 22 18C21.9228 21.708 20.5013 25.2616 18 28M18 8C15.4987 10.7384 14.0772 14.292 14 18C14.0772 21.708 15.4987 25.2616 18 28M18 8C12.4772 8 8 12.4772 8 18C8 23.5228 12.4772 28 18 28M18 8C23.5228 8 28 12.4772 28 18C28 23.5228 23.5228 28 18 28M8.50002 15H27.5M8.5 21H27.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_482_3735",
    x1: 18,
    y1: -0.00000107288,
    x2: 18,
    y2: 36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00DE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#008500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.985,
    stopColor: "#008500"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeLanguage);
export default __webpack_public_path__ + "static/media/Change-Language.5f5ada57a29ee29e6c17cc337856664f.svg";
export { ForwardRef as ReactComponent };